<template>
  <div>
<!--    <AlertTemplate :setting="setting"/>-->
    <div v-if="items.record && items.data">
      <a-descriptions :column="2">
<!--        <a-descriptions-item label="Legal Name">{{ items.data.legalName }}</a-descriptions-item>-->
        <a-descriptions-item label="Invoice Number">{{ items.record.factor_no || '__' }}</a-descriptions-item>
        <a-descriptions-item label="Invoice Date">{{ setDateFormat(items.record.issue_date) }}</a-descriptions-item>
        <a-descriptions-item label="Payment Due">{{ setDateFormat(items.record.due_date) }}</a-descriptions-item>
        <a-descriptions-item v-if="items.record.matters && items.record.matters.length" label="Our Reference">{{ items.record.matters[0].reference_code }}</a-descriptions-item>
      </a-descriptions>
    </div>
    <a-divider/>
    <DescriptionTblBill 
      :items="items"
      :setting="setting"
      @amountDueChanged="$emit('amountDueChanged', $event)"
    />
    <a-divider/>
    <div class="flex items-center justify-between">
      <div>
        <div v-if="setting.templates && setting.templates.avatar" class="flex space-y-logo">
<!--          <a-avatar :src="setting.templates.avatar" :size="120" style="box-shadow: rgb(0 0 0 / 10%) 0 1px 0 0"/>-->
<!--          <img :src="setting.templates.avatar" width="120" height="75" alt="avatar" class="object-cover"/>-->
          <img :src="setting.templates.avatar" alt="avatar" class="object-contain" style="width: 10rem;"/>
        </div>
        <a-avatar v-else :size="120" icon="user" />
      </div>
      <div v-if="setting.accounts">
        <strong>{{ setting.accounts.firm_name || '__' }}</strong>
        <div class="w-64">
          {{ setting.accounts.street }}
        </div>
      </div>
      <div v-if="setting.accounts">
        <strong>Contact Information</strong>
        <div class="w-64">
          {{ setting.accounts.phone }}
        </div>
        <div class="w-64">
          {{ setting.accounts.contact_email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DescriptionTblBill from "./components/DescriptionTblBill";
import AlertTemplate from "@/views/template/components/AlertTemplate";
import mixin from '@/views/mixin/mixin'

export default {
  name: "Template2",
  mixins:[mixin],
  props:{
    items:{
      type     : Object,
      required : true,
    },
    setting:{
      type     : Object,
      required : false,
    }
  },
  components:{
    DescriptionTblBill,
    AlertTemplate
  },
  mounted() {
    //console.log(this.setting,'setting')
  }
}
</script>

<style scoped>

</style>
